/**
 * ============================================================
 * COMBO IMAGE SWITCHER v6 — Overlay Approach
 * ============================================================
 * Switches the main product image based on:
 *   Color (Shopify option) + Brand (virtual) + Logo Location (virtual)
 *
 * Data source: window.comboImageMatrix (from product metafield)
 * Each entry: { url: "...", media_id: "gid://shopify/MediaImage/XXXXX" }
 *
 * HOW IT WORKS:
 * Shows an overlay <div> with the combo image URL directly on top of the
 * gallery viewer. Completely independent of Dawn's media-gallery and BCPO's
 * DOM manipulation — neither can affect the overlay.
 *
 * When no combo match exists, the overlay is hidden and the normal gallery
 * is fully visible and functional.
 * ============================================================
 */
(function () {
    'use strict';

    var URL_POLL_INTERVAL = 250;
    var lastURLSearch = '';

    // -----------------------------------------------------------------------
    // Helpers
    // -----------------------------------------------------------------------

    function log(msg, data) {
        // if (data !== undefined) {
        //     console.log('[ComboV6] ' + msg, data);
        // } else {
        //     console.log('[ComboV6] ' + msg);
        // }
    }

    /** Build normalized image map: "COLOR|BRAND|LOGO" -> { url, media_id } */
    function getImageMap() {
        var raw = window.comboImageMatrix || {};
        var map = {};
        for (var key in raw) {
            if (!raw.hasOwnProperty(key)) continue;
            var entry = raw[key];
            if (typeof entry === 'object' && entry.url) {
                map[key.trim().toUpperCase()] = entry;
            }
        }
        return map;
    }

    function getCheckedValue(name) {
        var el = document.querySelector('input[name="' + name + '"]:checked');
        return el ? el.value : null;
    }

    function getColorInputName() {
        if (window.bcpo_product && window.bcpo_product.options) {
            for (var i = 0; i < window.bcpo_product.options.length; i++) {
                var opt = window.bcpo_product.options[i];
                if (typeof opt === 'string') {
                    var low = opt.toLowerCase();
                    if (low.indexOf('color') !== -1 || low.indexOf('colour') !== -1) {
                        return 'name' + i;
                    }
                }
            }
        }
        return 'name0';
    }

    function getColor() { return getCheckedValue(getColorInputName()); }
    function getBrand() { return getCheckedValue('properties[Brand]'); }
    function getLogo() { return getCheckedValue('properties[Logo Location]'); }

    /** Look up the featured image URL for a given color from product variants */
    function getVariantFeaturedImageForColor(color) {
        if (!color || !window.bcpo_product || !window.bcpo_product.variants) return null;

        // Find the color option index
        var colorIndex = -1;
        if (window.bcpo_product.options) {
            for (var i = 0; i < window.bcpo_product.options.length; i++) {
                var opt = window.bcpo_product.options[i];
                if (typeof opt === 'string') {
                    var low = opt.toLowerCase();
                    if (low.indexOf('color') !== -1 || low.indexOf('colour') !== -1) {
                        colorIndex = i;
                        break;
                    }
                }
            }
        }
        if (colorIndex === -1) return null;

        // Find first variant with this color that has a featured image
        var optionKey = 'option' + (colorIndex + 1);
        for (var j = 0; j < window.bcpo_product.variants.length; j++) {
            var v = window.bcpo_product.variants[j];
            if (v[optionKey] === color && v.featured_image) {
                return {
                    url: v.featured_image.src,
                    media_id: v.featured_media ? String(v.featured_media.id) : null
                };
            }
        }
        return null;
    }

    function buildComboKey(c, b, l) {
        if (!c || !b || !l) return null;
        return (c + '|' + b + '|' + l).toUpperCase();
    }

    function getCurrentComboKey() {
        return buildComboKey(getColor(), getBrand(), getLogo());
    }

    // -----------------------------------------------------------------------
    // Overlay show / hide
    // -----------------------------------------------------------------------

    function getOverlay() { return document.getElementById('combo-image-overlay'); }
    function getOverlayImg() { return document.getElementById('combo-image-overlay-img'); }

    /** Extract numeric Shopify media ID from gid:// or plain number */
    function numericMediaId(id) {
        if (!id) return null;
        var s = String(id);
        return s.indexOf('/') !== -1 ? s.split('/').pop() : s;
    }

    // Currently displayed media ID (numeric) — used for modal scroll
    var currentDisplayMediaId = null;

    function showComboImage(entry) {
        var overlay = getOverlay();
        var img = getOverlayImg();

        log('showComboImage called', {
            hasOverlay: !!overlay,
            hasImg: !!img,
            entryUrl: entry ? entry.url : null
        });

        if (!overlay || !img) {
            log('❌ showComboImage aborted - missing elements');
            return;
        }

        var url = entry.url;
        // Append width param for a good-quality render if not already present
        if (url && url.indexOf('width=') === -1) {
            url += (url.indexOf('?') !== -1 ? '&' : '?') + 'width=1200';
        }

        log('Setting image src to: ' + url);

        // Force update src for iPhone Safari - remove attribute first to bypass cache
        // iPhone Safari aggressively caches and may not update if src "appears" the same
        img.removeAttribute('src');
        // Force reflow to ensure attribute removal is processed
        void img.offsetWidth;
        img.src = url;

        overlay.classList.add('combo-active');
        log('✓ combo-active class added, classList: ' + overlay.className);

        currentDisplayMediaId = numericMediaId(entry.media_id);

        // Update hidden form field so cart displays the combo image
        var propertyInput = document.getElementById('combo-image-property');
        if (propertyInput) {
            propertyInput.value = url;
        }
    }

    function hideComboImage() {
        var overlay = getOverlay();
        if (!overlay) return;
        overlay.classList.remove('combo-active');
        window.comboImageSwitcherActive = false;
    }

    // -----------------------------------------------------------------------
    // Core: evaluate combo and show/hide overlay
    // -----------------------------------------------------------------------

    var thumbnailOverride = false;

    function updateComboImage(source) {
        var comboKey = getCurrentComboKey();
        var imageMap = getImageMap();

        log('updateComboImage from ' + source, {
            comboKey: comboKey,
            hasMatch: !!(comboKey && imageMap[comboKey]),
            imageMapKeys: Object.keys(imageMap).length
        });

        if (comboKey && imageMap[comboKey]) {
            // Combo match always wins
            thumbnailOverride = false;
            showComboImage(imageMap[comboKey]);
            window.comboImageSwitcherActive = true;
            log('\u2713 Match: ' + comboKey + ' (' + source + ')');
        } else if (!thumbnailOverride) {
            // No combo match — show variant featured image for the current color
            // (needed because BCPO bypasses Dawn's gallery update with hide_variants on)
            var color = getColor();
            var variantData = getVariantFeaturedImageForColor(color);
            if (variantData) {
                showComboImage(variantData);
                window.comboImageSwitcherActive = false;
                log('Variant image for ' + color + ' (' + source + ')');
            } else {
                hideComboImage();
            }
            if (comboKey) log('No match: ' + comboKey + ' (' + source + ')');
        } else {
            // Thumbnail was clicked — user is browsing gallery, don't override
            log('Thumbnail override active, skipping (' + source + ')');
        }
    }

    // -----------------------------------------------------------------------
    // Gallery & VO visibility (prevent FOUC)
    // -----------------------------------------------------------------------

    function showGallery() {
        var g = document.querySelector('media-gallery');
        if (g) g.classList.add('combo-loaded');
    }

    function showVOContainer() {
        var els = document.querySelectorAll(
            '[id*="shopify-block"][id*="vo-product-options"], .bcpo-options-container, #bcpo-options-container'
        );
        for (var i = 0; i < els.length; i++) els[i].classList.add('vo-loaded');
    }

    // -----------------------------------------------------------------------
    // URL params — persist combo state across variant changes
    // -----------------------------------------------------------------------

    function getComboParamsFromURL() {
        var p = new URLSearchParams(window.location.search);
        return {
            color: p.get('combo_color'),
            brand: p.get('combo_brand'),
            logo: p.get('combo_logo')
        };
    }

    function updateComboURL(color, brand, logo) {
        var url = new URL(window.location);
        if (color) url.searchParams.set('combo_color', color);
        else url.searchParams.delete('combo_color');
        if (brand) url.searchParams.set('combo_brand', brand);
        else url.searchParams.delete('combo_brand');
        if (logo) url.searchParams.set('combo_logo', logo);
        else url.searchParams.delete('combo_logo');
        window.history.replaceState({}, '', url);
        lastURLSearch = url.search;
    }

    // -----------------------------------------------------------------------
    // Defaults & restore from URL
    // -----------------------------------------------------------------------

    function ensureDefaults() {
        if (!getBrand()) {
            var fb = document.querySelector('input[name="properties[Brand]"]');
            if (fb) { fb.checked = true; }
        }
        if (!getLogo()) {
            var fl = document.querySelector('input[name="properties[Logo Location]"]');
            if (fl) { fl.checked = true; }
        }
    }

    function restoreFromURL() {
        var p = getComboParamsFromURL();
        if (p.brand) {
            var bi = document.querySelector('input[name="properties[Brand]"][value="' + p.brand + '"]');
            if (bi) bi.checked = true;
        }
        if (p.logo) {
            var li = document.querySelector('input[name="properties[Logo Location]"][value="' + p.logo + '"]');
            if (li) li.checked = true;
        }
    }

    // -----------------------------------------------------------------------
    // Input change handler
    // -----------------------------------------------------------------------

    function handleInputChange(source) {
        thumbnailOverride = false;   // reset on any option change
        var color = getColor();
        var brand = getBrand();
        var logo = getLogo();
        updateComboURL(color, brand, logo);
        updateComboImage(source);
    }

    // -----------------------------------------------------------------------
    // URL polling — catches BCPO / Dawn programmatic changes
    // -----------------------------------------------------------------------

    function startURLPolling() {
        setInterval(function () {
            var current = window.location.search;
            if (current !== lastURLSearch) {
                lastURLSearch = current;
                // Re-evaluate combo on every URL change (variant changes, etc.)
                updateComboImage('URL-poll');
            }
        }, URL_POLL_INTERVAL);
    }

    // -----------------------------------------------------------------------
    // Attach listeners
    // -----------------------------------------------------------------------

    function attachListeners() {
        // Color
        var colorName = getColorInputName();
        var colorInputs = document.querySelectorAll('input[name="' + colorName + '"]');
        for (var i = 0; i < colorInputs.length; i++) {
            colorInputs[i].addEventListener('change', function (e) {
                if (e.target.closest('.bcpo-disabled')) {
                    //console.log('🚫 Combo switcher blocked - .bcpo-disabled on color');
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }
                handleInputChange('color');
            });
        }

        // Brand
        var brandInputs = document.querySelectorAll('input[name="properties[Brand]"]');
        for (var j = 0; j < brandInputs.length; j++) {
            brandInputs[j].addEventListener('change', function (e) {
                if (e.target.closest('.bcpo-disabled')) {
                    //console.log('🚫 Combo switcher blocked - .bcpo-disabled on brand');
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }
                handleInputChange('brand');
            });
        }

        // Logo Location
        var logoInputs = document.querySelectorAll('input[name="properties[Logo Location]"]');
        for (var k = 0; k < logoInputs.length; k++) {
            logoInputs[k].addEventListener('change', function (e) {
                if (e.target.closest('.bcpo-disabled')) {
                    //console.log('🚫 Combo switcher blocked - .bcpo-disabled on logo');
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }
                handleInputChange('logo');
            });
        }

        // Hide overlay when user manually clicks a gallery thumbnail
        var thumbnails = document.querySelector('[id^="GalleryThumbnails"]');
        if (thumbnails) {
            thumbnails.addEventListener('click', function (e) {
                var overlay = getOverlay();
                if (e.target.closest('button.thumbnail') && overlay && overlay.classList.contains('combo-active')) {
                    thumbnailOverride = true;
                    hideComboImage();
                    log('Overlay hidden (thumbnail click)');
                }
            });
        }

        // Open product lightbox modal when overlay image is clicked (desktop + mobile)
        var overlay = getOverlay();
        if (overlay) {
            var openModal = function (e) {
                if (e) e.preventDefault();
                var gallery = document.querySelector('media-gallery');
                if (!gallery) return;
                var opener = gallery.querySelector('modal-opener');
                if (!opener) return;
                var modal = document.querySelector(opener.getAttribute('data-modal'));
                if (modal && modal.show) {
                    modal.show(overlay);
                    var applySingleImageFilter = function (attempt) {
                        var content = modal.querySelector('.product-media-modal__content');
                        if (!content) return;
                        var allItems = content.querySelectorAll('[data-media-id]');
                        if (!allItems.length) {
                            if (attempt < 12) {
                                setTimeout(function () { applySingleImageFilter(attempt + 1); }, 50);
                            }
                            return;
                        }

                        var target = null;
                        if (currentDisplayMediaId) {
                            target = content.querySelector('[data-media-id="' + currentDisplayMediaId + '"]');
                        }
                        if (!target) {
                            target = content.querySelector('.active') || allItems[0];
                            log('Modal target fallback used', currentDisplayMediaId);
                        }

                        for (var i = 0; i < allItems.length; i++) {
                            var isTarget = allItems[i] === target;
                            allItems[i].style.display = isTarget ? '' : 'none';
                            allItems[i].classList.toggle('active', isTarget);
                        }

                        var overlayImg = getOverlayImg();
                        var targetImg = target && (target.tagName === 'IMG' ? target : target.querySelector('img'));
                        if (overlayImg && targetImg && overlayImg.src) {
                            targetImg.src = overlayImg.src;
                            if (overlayImg.srcset) targetImg.srcset = overlayImg.srcset;
                        }

                        if (target && target.scrollIntoView) {
                            target.scrollIntoView({ block: 'start', behavior: 'instant' });
                        }
                    };

                    setTimeout(function () { applySingleImageFilter(0); }, 30);
                }
            };

            var lastTouchOpenAt = 0;
            overlay.addEventListener('click', function (e) {
                if (Date.now() - lastTouchOpenAt < 500) return;
                openModal(e);
            });
            overlay.addEventListener('touchend', function (e) {
                lastTouchOpenAt = Date.now();
                openModal(e);
            }, { passive: false });
        }

        // Prevent native browser focus-scroll on BCPO radio buttons / labels.
        // When a radio near the bottom of the viewport is clicked, the browser
        // scrolls it towards the center — save & restore scroll position.
        var bcpoEl = document.getElementById('bcpo');
        if (bcpoEl) {
            bcpoEl.addEventListener('focusin', function (e) {
                if (!e.target || !e.target.matches('input[type="radio"]')) return;
                var y = window.scrollY || window.pageYOffset;
                requestAnimationFrame(function () {
                    if (Math.abs((window.scrollY || window.pageYOffset) - y) > 2) {
                        window.scrollTo(0, y);
                    }
                });
            });
        }
    }

    // -----------------------------------------------------------------------
    // Init
    // -----------------------------------------------------------------------

    function init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init);
            return;
        }

        log('Init (overlay mode)...');
        var attempts = 0;

        function waitForDeps() {
            attempts++;

            var hasBcpoProduct = !!(window.bcpo_product && window.bcpo_product.options);
            var hasComboMatrix = !!(window.comboImageMatrix && Object.keys(window.comboImageMatrix).length > 0);
            var hasBrandInput = !!document.querySelector('input[name="properties[Brand]"]');
            var hasGallery = !!document.querySelector('media-gallery');
            var hasOverlay = !!document.getElementById('combo-image-overlay');

            var ready = hasBcpoProduct && hasComboMatrix && hasBrandInput && hasGallery && hasOverlay;

            // Log every 10 attempts to avoid spam
            if (attempts % 10 === 1 || ready) {
                log('Dependency check (attempt ' + attempts + ')', {
                    bcpo_product: hasBcpoProduct,
                    comboImageMatrix: hasComboMatrix,
                    brandInput: hasBrandInput,
                    gallery: hasGallery,
                    overlay: hasOverlay,
                    ready: ready
                });
            }

            if (ready) {
                lastURLSearch = window.location.search;

                // Restore from URL or set defaults
                var p = getComboParamsFromURL();
                if (p.brand || p.logo) {
                    restoreFromURL();
                }
                ensureDefaults();

                // Initial URL sync
                updateComboURL(getColor(), getBrand(), getLogo());

                // Attach all listeners
                attachListeners();

                // Start polling
                startURLPolling();

                // Initial combo check
                updateComboImage('init');

                // Show gallery and VO
                showGallery();
                showVOContainer();

                log('✓ Ready');
                return;
            }

            if (attempts < 50) {
                setTimeout(waitForDeps, 100);
            } else {
                log('⚠ Timeout waiting for dependencies');
                showGallery();
                showVOContainer();
            }
        }

        waitForDeps();
    }

    init();
})();
